import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var Iframe =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Iframe, _React$Component);

  function Iframe() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Iframe.prototype;

  _proto.render = function render() {
    return React.createElement("iframe", {
      className: "tab-content iframe",
      frameBorder: '0',
      width: '100%',
      height: '800',
      src: this.props.src
    });
  };

  return Iframe;
}(React.Component);

export default Iframe;